import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { MultimediaDTO } from "../models/Multimedia.model";
import { MultimediaQuery } from "../models/MultimediaQuery.model";
import { MulimediaResponse } from "../models/MultimediaResponse";

export class MultimediaService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/multimedia`;
  }

  async saveFile(multimedia: MultimediaDTO): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}`;
    const response = await axios.post(serviceURL, multimedia);
    return response.data;
  }

  async updateFile(
    multimedia: MultimediaDTO,
    id: string
  ): Promise<Response<MulimediaResponse>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, multimedia);
    return response.data;
  }

  async getFilesByFilters(
    query: MultimediaQuery
  ): Promise<Response<MulimediaResponse>> {
    const serviceURL = `${this.baseUrl}/get-by-filters-arrays`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async deleteFile(id: string): Promise<Response<MulimediaResponse>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }

  async updateStateFileById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameMultimedia: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
